import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';


export default register('grid-block-section', {
  onLoad() {
    const button = this.container.querySelector('.video-container .play-btn');

    document.querySelectorAll('.video-container').forEach((el) => {
      el.addEventListener('click', (evt) => {
        const player = el.querySelector('video')
        const button = el.querySelector('.play-btn')

        if (player.paused == true) {
          // Play the video
          player.play();
    
          button.style.display = 'none';
        } else {
          // Pause the video
          player.pause();
    
          button.style.display = 'block';
        }
      })
    })
  },

});
